import React from 'react';
import Helper from '../../helper';

const PartnerLogos = () => {
  const userInfo = Helper();
  const desktopLogos = [
    { src: "https://images.staticcontent.io/casino/banner/loginimages/evolution.png", alt: "Evolution" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/ezugi.png", alt: "Ezugi" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/pragmatic-live.png", alt: "Pragmatic Live" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/betgames.png", alt: "Betgames" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/ssg.png", alt: "Super Spade Games" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/betsoft.png", alt: "Betsoft" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/spribe.png", alt: "Spribe" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/Evoplay.png", alt: "Evoplay" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/logo-18plus.svg", alt: "+18" }
  ];

  const mobileLogos = [
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/evolution.svg", alt: "Evolution" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/ezugi.svg", alt: "Ezugi" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/pragmatic.svg", alt: "Pragmatic Live" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/betgames.svg", alt: "Betgames" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/superspade.svg", alt: "Super Spade Games" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/betsoft.svg", alt: "Betsoft" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/spribe.svg", alt: "Spribe" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/evoplay.svg", alt: "Evoplay" },
    { src: "https://images.staticcontent.io/casino/banner/loginimages/mobile/logo-18plus.svg", alt: "+18" }
  ];

  return (
    <div className={`partner_logo bg-[#fff] lg:bg-[#045662] md:p-6 mt-2 md:border-t ${userInfo ? "block hidden": "block"}`} style={{ borderTopColor: '#606060' }}>
      {/* Desktop Logos */}
      <ul className="hidden md:flex flex-wrap  justify-center gap-4 md:gap-6 mb-4">
        {desktopLogos.map((logo, index) => (
          <li key={`desktop-${index}`} className="hover:scale-105 transition-transform">
            <a href="#" className="block">
              <img 
                src={logo.src} 
                alt={logo.alt} 
                className="h-10 md:h-12 object-contain"
              />
            </a>
          </li>
        ))}
      </ul>

      {/* Mobile Logos */}
      <ul className="flex md:hidden flex-wrap justify-center gap-3 mb-4">
        {mobileLogos.map((logo, index) => (
          <li key={`mobile-${index}`} className="hover:scale-105 transition-transform">
            <a href="#" className="block">
              <img 
                src={logo.src} 
                alt={logo.alt} 
                className="h-8 w-[39px] object-contain"
              />
            </a>
          </li>
        ))}
      </ul>

      {/* Age Restriction Text */}
      <p className="text-xs sm:text-sm md:text-base text-center text-gray-800 md:text-blue-100 font-medium leading-5 sm:leading-6">
        You must be over 18 years old, or the legal age at which gambling or gaming activities are allowed under the law or jurisdiction that applies to you. You must reside in a country in which access to online gambling to its residents.
      </p>

      {/* Hidden Links */}
      <div className="hidden">
        <ul className="flex flex-wrap justify-center gap-4">
          {['Home', 'About Us', 'Terms and Conditions', 'Privacy Policy', 'Betting Rules', 'Deposits and Withdrawals Rules'].map((item, index) => (
            <li key={index}>
              <a href="#" className="text-sm text-gray-700 hover:text-blue-600">
                {item}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PartnerLogos;
